<template>
	<v-modal>
		<template v-slot:header>
			<h1>Fact Find Data</h1>
		</template>
		<section class="" v-for="(section, sectionIndex) in structure">
			<header>
				<h1 class="beta" v-html="section.title"/>
			</header>
			<div class="detail-list">
				<dl class="detail-list__item" v-for="(question, questionIndex) in section.questions">
					<dt v-html="question.question"/>
					<dd v-html="data[question.apiMapping.inbound]"/>
				</dl>
			</div>
		</section>
		<template v-slot:footer>
			<ul class="v-modal__footer__actions">
				<li>
					<button @click.prevent="$vmodal.close()" class="button button--secondary">Close</button>
				</li>
			</ul>
		</template>
	</v-modal>
</template>
<script>
export default {
	props: {
		structure: {
			required: true,
			type: Array,
		},
		data: {
			required: true,
			type: Array,
		},
	}
};
</script>
